<template>
  <div class="vehicle-cards">
    <div class="cars-grid">
      <div v-for="car in displayedVehicles" :key="car.id" class="car-card">
        <div class="car-image">
          <img :src="car.image" :alt="car.name">
          <div class="car-badge">{{ car.category }}</div>
        </div>
        <div class="car-info">
          <h3 class="car-name">{{ car.name }}</h3>
          <p class="car-description">{{ car.description }}</p>
          <div class="car-specs">
            <span class="spec"><i class="fas fa-cog"></i> {{ car.transmission }}</span>
            <span class="spec"><i class="fas fa-gas-pump"></i> {{ car.fuel }}</span>
            <span class="spec"><i class="fas fa-users"></i> {{ car.seats }} seats</span>
            <span class="spec"><i class="fas fa-suitcase"></i> {{ car.luggage }} bags</span>
          </div>
          <div class="car-features">
            <span v-for="feature in car.features" :key="feature" class="feature">{{ feature }}</span>
          </div>
          <div class="car-actions">
            <button class="car-btn primary" @click="bookVehicle(car)">Book Now</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VehicleCards',
  props: {
    limit: {
      type: Number,
      default: null
    },
    category: {
      type: String,
      default: ''
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      vehicles: [
        {
          id: 1,
          name: 'Land Cruiser Prado TXL',
          category: 'Luxury SUV',
          image: '/images/vehicles/txl2024.jpeg',
          transmission: 'Automatic',
          fuel: 'Diesel',
          seats: 7,
          luggage: 4,
          description: 'Perfect for family adventures in Rwanda. This versatile SUV combines comfort, safety, and fuel efficiency, making it ideal for exploring Rwanda\'s diverse landscapes.',
          features: ['Air Conditioning', 'GPS Navigation', 'Bluetooth Connectivity', 'All-Wheel Drive', 'Safety Features', 'Spacious Interior']
        },
        {
          id: 2,
          name: 'Coastal',
          category: 'Luxury Bus',
          image: '/images/vehicles/coastel.jpeg',
          transmission: 'Automatic',
          fuel: 'Diesel',
          seats: 28,
          luggage: 8,
          description: 'The Coastal is a premium luxury bus perfect for group travel, corporate events, and tours in Rwanda. Spacious and comfortable for large groups with ample luggage space.',
          features: ['28 Comfortable Seats', 'Air Conditioning', 'Ample Luggage Space', 'Entertainment System', 'Reclining Seats', 'Onboard Restroom']
        },
        {
          id: 3,
          name: 'TOYOTA RAV4',
          category: 'SUV',
          image: '/images/vehicles/rava42008.jpeg',
          transmission: 'Automatic',
          fuel: 'Petrol',
          seats: 5,
          luggage: 5,
          description: 'Reliable and versatile SUV perfect for exploring Rwanda. Combines excellent fuel efficiency with robust performance for both city and off-road adventures.',
          features: ['All-Wheel Drive', 'Safety Sense 2.0', 'GPS Navigation', 'Bluetooth Connectivity', 'Air Conditioning', 'Spacious Interior']
        },
        {
          id: 4,
          name: 'TOYOTA FORTUNER',
          category: 'Luxury SUV',
          image: '/images/vehicles/fortunes.jpeg',
          transmission: 'Automatic',
          fuel: 'Diesel',
          seats: 7,
          luggage: 6,
          description: 'The Toyota Fortuner combines rugged capability with premium comfort, making it perfect for both city driving and off-road adventures in Rwanda.',
          features: ['4x4 Capability', 'Leather Seats', 'Touchscreen Display', 'Dual Zone AC', 'Advanced Safety', 'Roof Rails']
        },
        {
          id: 5,
          name: 'TOYOTA TUNDRA',
          category: 'Pickup Truck',
          image: '/images/vehicles/tundra.jpeg',
          transmission: 'Automatic',
          fuel: 'Petrol',
          seats: 5,
          luggage: 8,
          description: 'The powerful Toyota Tundra offers exceptional towing capacity and off-road performance, ideal for both work and adventure in Rwanda.',
          features: ['V8 Engine', 'Towing Package', 'Off-Road Suspension', 'Spacious Cabin', 'Infotainment System', 'Heated Seats']
        },
        {
          id: 6,
          name: 'LANDCRUISER SAFARI CAR',
          category: 'Safari Vehicle',
          image: '/images/vehicles/safaricar.jpeg',
          transmission: 'Automatic',
          fuel: 'Petrol',
          seats: 5,
          luggage: 4,
          description: 'Reliable and spacious SUV perfect for family trips and exploring Rwanda. Excellent safety features and comfortable ride quality.',
          features: ['Honda SENSING', 'Spacious Interior', 'GPS Navigation', 'Bluetooth Connectivity', 'Safety Features', 'All-Weather Capable']
        },
        {
          id: 7,
          name: 'RAV4 2021',
          category: 'SUV',
          image: '/images/cars/luxury/prado.jpg',
          transmission: 'Automatic',
          fuel: 'Petrol',
          seats: 5,
          luggage: 4,
          description: 'Stylish and efficient SUV with premium interior and excellent driving dynamics. Perfect for exploring Rwanda with style.',
          features: ['Premium Interior', 'SKYACTIV Technology', 'GPS Navigation', 'Bose Sound System', 'Safety Features', 'Fuel Efficient']
        },
        {
          id: 8,
          name: 'TOYOTA RAV4 2008',
          category: 'SUV',
          image: '/images/vehicles/rava42008.jpeg',
          transmission: 'Automatic',
          fuel: 'Petrol',
          seats: 5,
          luggage: 4,
          description: 'Reliable and efficient RAV4 from 2008, perfect for city driving and weekend getaways in Rwanda.',
          features: ['Air Conditioning', 'All-Wheel Drive', 'Spacious Interior', 'Roof Rails', 'ABS Brakes', 'Power Windows']
        },
        {
          id: 9,
          name: 'LANDCRUISER SAFARI',
          category: 'Safari Vehicle',
          image: '/images/vehicles/safaricar.jpeg',
          transmission: 'Manual',
          fuel: 'Diesel',
          seats: 7,
          luggage: 6,
          description: 'The ultimate safari vehicle for exploring Rwanda\'s national parks and rugged terrains with comfort and reliability.',
          features: ['Pop-up Roof', '4x4 Capability', 'Raised Suspension', 'Safari Seating', 'Large Windows', 'Cooler Box']
        },
        {
          id: 10,
          name: 'LANDCRUISER TXL 2024',
          category: 'Luxury SUV',
          image: '/images/vehicles/txl2024.jpeg',
          transmission: 'Automatic',
          fuel: 'Diesel',
          seats: 7,
          luggage: 6,
          description: 'The latest 2024 Land Cruiser TXL model with premium features, perfect for both city and off-road adventures in Rwanda.',
          features: ['Leather Seats', 'Sunroof', '360 Camera', 'Premium Sound', 'LED Headlights', 'Advanced Safety']
        },
        {
          id: 11,
          name: 'LANDCRUISER PRADO',
          category: 'Luxury SUV',
          image: '/images/cars/luxury/prado-2.jpg',
          transmission: 'Automatic',
          fuel: 'Petrol',
          seats: 5,
          luggage: 3,
          description: 'Compact and fuel-efficient hatchback perfect for city driving in Rwanda. Easy to park and navigate through busy streets.',
          features: ['Fuel Efficient', 'Easy Parking', 'GPS Navigation', 'Air Conditioning', 'Compact Size', 'Affordable']
        },
        {
          id: 12,
          name: 'SAFARI LANDCRUISER 2',
          category: 'Safari Vehicle',
          image: '/images/vehicles/safaricar2.jpeg',
          transmission: 'Manual',
          fuel: 'Diesel',
          seats: 8,
          luggage: 5,
          description: 'Another excellent safari vehicle option for group tours and wildlife viewing in Rwanda\'s national parks.',
          features: ['Pop-up Roof', '4x4 Capability', 'Raised Suspension', 'Safari Seating', 'Large Windows', 'Cooler Box']
        },
        {
          id: 13,
          name: 'KIA Niro',
          category: 'SUV',
          image: '/images/cars/suv/kia-sportage.jpg',
          transmission: 'Automatic',
          fuel: 'Petrol',
          seats: 5,
          luggage: 2,
          description: 'Fun and agile small car perfect for navigating Rwanda\'s streets. Great for solo travelers or small groups.',
          features: ['Agile Handling', 'Fuel Efficient', 'Easy Parking', 'Air Conditioning', 'Fun to Drive', 'Budget Friendly']
        },
        {
          id: 14,
          name: 'LAND CRUISER V8',
          category: 'Luxury SUV',
          image: '/images/vehicles/v8.jpg',
          transmission: 'Automatic',
          fuel: 'Diesel',
          seats: 7,
          luggage: 6,
          description: 'The powerful Land Cruiser V8 offers unmatched performance and luxury for your Rwandan adventures, both on and off the road.',
          features: ['V8 Engine', 'Premium Leather', '4x4 Capability', 'Climate Control', 'Advanced Safety', 'Sunroof']
        },
        {
          id: 15,
          name: 'LAND CRUISER V8 PREMIUM',
          category: 'Luxury SUV',
          image: '/images/vehicles/v8_3.jpg',
          transmission: 'Automatic',
          fuel: 'Diesel',
          seats: 7,
          luggage: 6,
          description: 'The premium version of the Land Cruiser V8 with additional luxury features for the ultimate driving experience in Rwanda.',
          features: ['V8 Engine', 'Premium Sound System', '4x4 Capability', 'Heated Seats', '360 Camera', 'Panoramic Sunroof']
        }
      ]
    }
  },
  computed: {
    displayedVehicles () {
      let filtered = this.vehicles

      // Filter by category if specified
      if (this.category) {
        filtered = filtered.filter(vehicle =>
          vehicle.category.toLowerCase().includes(this.category.toLowerCase())
        )
      }

      // Apply limit if specified and not showing all
      if (this.limit && !this.showAll) {
        filtered = filtered.slice(0, this.limit)
      }

      return filtered
    }
  },
  methods: {
    bookVehicle (car) {
      // Save vehicle information to localStorage
      const vehicleData = {
        id: car.id,
        name: car.name,
        category: car.category,
        image: car.image,
        transmission: car.transmission,
        fuel: car.fuel,
        seats: car.seats,
        luggage: car.luggage,
        description: car.description,
        features: car.features
      }
      localStorage.setItem('selectedVehicle', JSON.stringify(vehicleData))

      // Emit event to parent component
      this.$emit('book-vehicle', car)

      // Navigate to booking page
      this.$router.push({ path: '/book' })
    }
  }
}
</script>

<style scoped>
.vehicle-cards {
  width: 100%;
}

.cars-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2.5rem;
}

.car-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #F0F0F0;
  display: flex;
  flex-direction: column;
  position: relative;
}

.car-card:hover {
  transform: translateY(-12px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
  border-color: #FF8C42;
}

.car-image {
  position: relative;
  height: 280px;
  overflow: hidden;
  background: linear-gradient(135deg, #F8F9FA 0%, #E5E7EB 100%);
}

.car-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.car-card:hover .car-image img {
  transform: scale(1.1);
}

.car-badge {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: #FF8C42;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.875rem;
}

.car-info {
  padding: 2rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.car-name {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
  color: #002F6C;
  line-height: 1.3;
}

.car-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  font-size: 0.95rem;
}

.car-specs {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.spec {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #555;
}

.spec i {
  color: #FF6B35;
  width: 16px;
}

.car-features {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 25px;
}

.feature {
  background: #f8f9fa;
  color: #002F6C;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 500;
}

.car-actions {
  margin-top: auto;
  padding-top: 1.5rem;
  display: flex;
  gap: 10px;
}

.car-btn {
  flex: 1;
  padding: 1rem 2rem;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.car-btn.primary {
  background: linear-gradient(135deg, #FF6B35, #FF8C42);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
}

.car-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 107, 53, 0.4);
}

.car-btn.primary:hover {
  background: linear-gradient(135deg, #E67E22, #FF6B35);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .cars-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .cars-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  .car-card {
    max-width: 500px;
    margin: 0 auto;
  }
  .car-image {
    height: 220px;
  }
  .car-specs {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
  }
  .spec {
    font-size: 0.8rem;
    padding: 0.2rem 0.6rem;
  }
  .car-features {
    gap: 0.5rem;
  }
  .feature {
    font-size: 0.75rem;
    padding: 0.3rem 0.8rem;
  }
}

@media (max-width: 480px) {
  .car-image {
    height: 200px;
  }
  .car-info {
    padding: 1.25rem;
  }
  .car-name {
    font-size: 1.1rem;
  }
  .car-description {
    font-size: 0.9rem;
  }
  .car-specs {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}
</style>
